import React from 'react'
import { useNavigate } from 'react-router-dom'
import { useApplication } from '../services/application'
import { AmplifyAuth } from '../services/amplifyAuth'
import { ROUTE_SIGNIN } from '../constants'
import { clearAdminMfaSessionSatisfied } from '../utils/adminMfaSession'
import { clearMfaReminderBannerDismissed } from '../utils/mfaReminderBanner'

export default function useLogout() {
  const navigate = useNavigate()
  const application = useApplication()

  // eslint-disable-next-line no-undef
  return React.useCallback(() => {
    const username = application.auth?.username

    AmplifyAuth.signOut()
      .then(() => application.authorize(undefined, false))
      .then(() => {
        clearAdminMfaSessionSatisfied(username)
        clearMfaReminderBannerDismissed(username)
        navigate(ROUTE_SIGNIN.path)
      })
      .catch(console.warn)
  }, [navigate, application])
}
